import { render, staticRenderFns } from "./ShipperSettings.vue?vue&type=template&id=6b846e74&"
import script from "./ShipperSettings.vue?vue&type=script&lang=js&"
export * from "./ShipperSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports